import { render, staticRenderFns } from "./AddProfil.vue?vue&type=template&id=53615490&scoped=true"
import script from "./AddProfil.vue?vue&type=script&lang=js"
export * from "./AddProfil.vue?vue&type=script&lang=js"
import style0 from "./AddProfil.vue?vue&type=style&index=0&id=53615490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53615490",
  null
  
)

export default component.exports